export const REPLACE_SPEAKERS = "REPLACE_SPEAKERS";
export type REPLACE_SPEAKERS = typeof REPLACE_SPEAKERS;
export const ADD_SPEAKER = "ADD_SPEAKER";
export type ADD_SPEAKER = typeof ADD_SPEAKER;
export const REMOVE_SPEAKER = "REMOVE_SPEAKER";
export type REMOVE_SPEAKER = typeof REMOVE_SPEAKER;
export const SET_SPEAKER = "SET_SPEAKER";
export type SET_SPEAKER = typeof SET_SPEAKER;

export const PITCHART_DOCUMENT_ID = "PITCHART_DOCUMENT_ID";
export type PITCHART_DOCUMENT_ID = typeof PITCHART_DOCUMENT_ID;
export const PITCHART_COLLECTION_ID = 'PITCHART_COLLECTION_ID';
export type PITCHART_COLLECTION_ID = typeof PITCHART_COLLECTION_ID;
export const LISTENED_DOCUMENT_IDS = 'LISTENED_DOCUMENT_IDS';
export type LISTENED_DOCUMENT_IDS = typeof LISTENED_DOCUMENT_IDS;
export const PARENT_PITCHART_DOCUMENT_DATA = 'PARENT_PITCHART_DOCUMENT_DATA'
export type PARENT_PITCHART_DOCUMENT_DATA = typeof PARENT_PITCHART_DOCUMENT_DATA;
export const CURRENT_PITCHART_DOCUMENT_DATA = 'CURRENT_PITCHART_DOCUMENT_DATA'
export type CURRENT_PITCHART_DOCUMENT_DATA = typeof CURRENT_PITCHART_DOCUMENT_DATA;
export const CURRENT_PITCHART_VERSIONS = 'CURRENT_PITCHART_VERSIONS'
export type CURRENT_PITCHART_VERSIONS = typeof CURRENT_PITCHART_VERSIONS;
export const UPDATE_MULTIPLE_FIELDS = 'UPDATE_MULTIPLE_FIELDS'
export type UPDATE_MULTIPLE_FIELDS = typeof UPDATE_MULTIPLE_FIELDS;

export const CURRENT_USER_ROLE = 'CURRENT_USER_ROLE';
export type CURRENT_USER_ROLE = typeof CURRENT_USER_ROLE;
export const ADMIN_ROLE= "Admin";
export const TEACHER_ROLE="Teacher";
export const STUDENT_ROLE="Student";
export const RESEARCHER_ROLE="Linguistic Researcher";
export const OTHER_ROLE="Other";

export const MAXIMUM_PITCH_ART_VERSIONS_ALLOWED = 3;
export const MAXIMUN_RECIPIENTS_ALLOWED = 3;
export const MAXIMUM_MESSAGES_PER_PAGE = 5;
export const SEND_MSG_TOOLTIP_CONTENT="This tab lets users send messages to other users within the MeTILDA application using its built-in communication system.";
export const SEND_EMAIL_TOOLTIP_CONTENT="This tab enables users to send emails. If the recipient is not a user of MeTILDA, users can enter their email address to send messages."
export const CREATE_PITCH_ART_PAGE_TOOLTIP ="This tab is exclusively available to individuals who are researchers or teachers."


export const SET_WORD = "SET_WORD";
export type SET_WORD = typeof SET_WORD;
export const SET_WORD_TRANSLATION = "SET_WORD_TRANSLATION";
export type SET_WORD_TRANSLATION = typeof SET_WORD_TRANSLATION;
export const SET_UPLOAD_ID = "SET_UPLOAD_ID";
export type SET_UPLOAD_ID = typeof SET_UPLOAD_ID;
export const SET_SPEAKER_NAME = "SET_SPEAKER_NAME";
export type SET_SPEAKER_NAME = typeof SET_SPEAKER_NAME;
export const SET_LATEST_ANALYSIS_ID = "SET_UPLOAD_ID";
export type SET_LATEST_ANALYSIS_ID = typeof SET_LATEST_ANALYSIS_ID;
export const ADD_LETTER = "ADD_LETTER";
export type ADD_LETTER = typeof ADD_LETTER;
export const REMOVE_LETTER = "REMOVE_LETTER";
export type REMOVE_LETTER = typeof REMOVE_LETTER;
export const RESET_LETTERS = "RESET_LETTERS";
export type RESET_LETTERS = typeof RESET_LETTERS;
export const SET_LETTER_SYLLABLE = "SET_LETTER_SYLLABLE";
export type SET_LETTER_SYLLABLE = typeof SET_LETTER_SYLLABLE;
export const SET_LETTER_TIME = "SET_LETTER_TIME";
export type SET_LETTER_TIME = typeof SET_LETTER_TIME;
export const SET_WORD_TIME = "SET_WORD_TIME";
export type SET_WORD_TIME = typeof SET_WORD_TIME;
export const SET_ACTIVE_LETTER = "SET_ACTIVE_LETTER";
export type SET_ACTIVE_LETTER = typeof SET_ACTIVE_LETTER;
export const MANUAL_PITCH_ADJUST = "MANUAL_PITCH_ADJUST";
export type MANUAL_PITCH_ADJUST = typeof MANUAL_PITCH_ADJUST;
export const LINE_AND_DOT_COLOR = "LINE_AND_DOT_COLOR";
export type LINE_AND_DOT_COLOR = typeof LINE_AND_DOT_COLOR;
